document.addEventListener('turbolinks:load', () => {
  $('#profile-weekly-checkbox').change(function(e) {
    $('#profile-weekday-select').prop('disabled', !e.currentTarget.checked)
  })

  $('#profile-monthly-checkbox').change(function(e) {
    $('#profile-monthday-select').prop('disabled', !e.currentTarget.checked)
  })
})
